import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';

@Directive()
export class NimbusFilterSummaryBase {
  @Input()
  public filterName: string;
  @Input()
  public summary: string;
  @Input()
  public tooltip: string;
  @Input()
  public disabled: boolean;
  @Input()
  public isValueEmpty: boolean;
  @Input()
  public hasError: boolean;

  @Output()
  public summaryClick = new EventEmitter<void>();
  @Output()
  public removeFilter = new EventEmitter<void>();

  public readonly ICONS = ICONS;

  public constructor(public readonly el: ElementRef) {}

  public onSummaryClick(): void {
    if (!this.disabled) {
      this.summaryClick.emit();
    }
  }

  public onRemoveFilter(ev: MouseEvent): void {
    if (this.disabled) {
      return;
    }
    ev.stopPropagation();
    ev.preventDefault();
    this.removeFilter.emit();
  }
}
